import "bootstrap/dist/css/bootstrap.min.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import "bootstrap";
import "@fortawesome/fontawesome-free/css/all.css";
import "vue3-country-intl/lib/vue3-country-intl.css";

axios.defaults.baseURL = "https://api.lagoslawntennisclub1895.com/api/v1";
//axios.defaults.baseURL = "http://localhost:8888/lltc_backend/api/v1";
axios.interceptors.request.use(
  (config) => {
    const dynamicToken = localStorage.getItem("wertyuiojhdfghhdrtfyguh");
    if (dynamicToken) {
      config.headers.Authorization = `Bearer ${dynamicToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const vuetify = createVuetify({
  components,
  directives,
});

createApp(App).use(store).use(router).use(vuetify).mount("#app");
